import { MissingDataException } from '@nu-art/ts-common';
import { EpicKeyRing_FhirEpic } from '../epic-keyring/types.js';
export function buildEpicJwksKid(keyring, versionId, kidEnv) {
    if (keyring === EpicKeyRing_FhirEpic) {
        if (!kidEnv)
            throw new MissingDataException('fhir-epic kid requires kidEnv');
        return `${keyring}:${kidEnv}:${versionId}`;
    }
    return `${keyring}:${versionId}`;
}
export function fhirEpicRungsToPublish(ladder, thisEnv) {
    const idx = ladder.findIndex(rung => rung.env === thisEnv);
    if (idx < 0)
        throw new MissingDataException(`thisEnv=${thisEnv} is not on fhirEpicKeyLadder`);
    return ladder.slice(0, idx + 1);
}
//# sourceMappingURL=jwks-kid.js.map